var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search__products-item" }, [
    _c(
      "a",
      {
        staticClass: "search__products-anchor",
        attrs: {
          href: _vm.url,
          "data-tracking-event": "event",
          "data-tracking-category": "navigation",
          "data-tracking-action": "fly-out klick",
          "data-tracking-label": _vm.name,
          "data-index": _vm.index,
        },
      },
      [
        _c("img", {
          staticClass: "search__products-image",
          attrs: {
            src: _vm.imageUrl,
            title: _vm.name,
            alt: "Jungheinrich Profishop-Transportkarren",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "search__products-text-wrapper" }, [
          _c("div", {
            staticClass: "search__products-name",
            domProps: { innerHTML: _vm._s(_vm.highlightedName) },
          }),
          _vm._v(" "),
          _vm.minPrice.length && _vm.oldPrice.length
            ? _c("div", { staticClass: "search__products-price" }, [
                _c("span", { staticClass: "search__products-price-new" }, [
                  _vm._v(_vm._s(_vm.minPrice)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "search__products-price-old" }, [
                  _vm._v(_vm._s(_vm.oldPrice)),
                ]),
              ])
            : _c("div", { staticClass: "search__products-price" }, [
                _vm.minPrice.length
                  ? _c(
                      "span",
                      { staticClass: "search__products-price-current" },
                      [_vm._v(_vm._s(_vm.minPrice))]
                    )
                  : _vm._e(),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }